import React from 'react'
import PropTypes from 'prop-types'
import './_switch.scss'
import { useTranslation } from '../../../hooks'

const Switch = ({ name, label, placeholder, value, errorMessage, onChange = () => {}, onBlur = () => {}, disabled }) => {
  const { i18n } = useTranslation();
  const compileClassNames = () => {
    let className = 'field field--switch';
    if (errorMessage) className += ' field field--textarea';
    if (disabled) className += ' field--disabled';
    return className;
  }

  return (
    <label className={compileClassNames()}>
      <input disabled={disabled} onBlur={onBlur} className="field-switch__checkbox" onChange={onChange} type="checkbox" name={name} checked={!!value} value={value} />
      <span className="field__label">{i18n(label)}</span>
      <div className="field__input-wrapper">
        <div className="field__input">
          <span className="field--switch__placeholder">{i18n(placeholder)}</span>
          <span className="field--switch__switch" />
        </div>
      </div>
      {errorMessage && <small className="field__error-message">{i18n(errorMessage)}</small>}
    </label>
  )
}


Switch.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
  errorMessage: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool
}

export default Switch
